export default "<div [ngClass]=\"(appService.openMobileMenu | async) ? 'mobile-nav-active' : ''\">\r\n    <router-outlet></router-outlet>\r\n</div>"